// extracted by mini-css-extract-plugin
export default {"terms-of-service-page":"styles_terms-of-service-page__tpTUn"};